import { Text } from '@village/ui';
import styled from 'styled-components';
import { device } from 'utils/device';

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
`;

const FormContainer = styled.div`
    display: grid;
    gap: 1.5rem;
    padding: 2.5rem;
    width: 43.75rem;
    border-radius: 8px;
    background: ${({ theme }) => theme.vui.colors.surface.white};

    & button {
        margin-top: 0.5rem;
    }

    @media ${device.maxTablet} {
        padding: 2rem 1rem;
    }

    @media ${device.minLaptop} {
        margin: 0 auto;
    }
`;

const DepartmentHelperText = styled(Text)`
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.vui.colors.text.grayMuted};
`;

export { Wrapper, FormContainer, DepartmentHelperText };
